module.exports = __webpack_public_path__ + "img/state.3c37a7cf.png";